import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Document footer — used inside <TemplateDocument>'s `footer` slot.
 * Repeats on every printed page (positioned by .pdf-repeat-footer).
 */
export function TemplateFooter(props) {
    return (_jsxs("div", { className: "flex justify-between font-sans text-[9px] text-stone-500", children: [_jsx("span", { children: props.formNumber }), _jsx("span", { children: "Regta" })] }));
}
//# sourceMappingURL=Footer.js.map